export default "__VITE_ASSET__D2mWaXT7__"